/** "1–10 of 1,234" style row counts for DataGrid / TablePagination footers */
export function formatPaginationDisplayedRows({
  from,
  to,
  count,
}: {
  from: number;
  to: number;
  count: number;
}): string {
  const f = (n: number) => n.toLocaleString('en-US');
  if (count === -1) {
    return `${f(from)}–${f(to)} of more than ${f(to)}`;
  }
  return `${f(from)}–${f(to)} of ${f(count)}`;
}
